/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GiftCardCancelPaymentMutationVariables = Types.Exact<{
  input: Types.CancelOrderPaymentIntentInput;
}>;

export type GiftCardCancelPaymentMutation = {
  readonly __typename?: 'Mutation';
  readonly cancelOrderPaymentIntent: {
    readonly __typename: 'CancelOrderPaymentIntentResponse';
    readonly paymentIntentId: string;
    readonly success: boolean;
  };
};

export const GiftCardCancelPaymentDocument = gql`
  mutation GiftCardCancelPayment($input: CancelOrderPaymentIntentInput!) {
    cancelOrderPaymentIntent(input: $input) {
      __typename
      paymentIntentId
      success
    }
  }
`;

export function useGiftCardCancelPaymentMutation() {
  return Urql.useMutation<GiftCardCancelPaymentMutation, GiftCardCancelPaymentMutationVariables>(
    GiftCardCancelPaymentDocument,
  );
}
